<template>
  <b-container>
    <ObjectListTabs>
      <template slot-scope="{}">
        <b-nav-item :to="{name: 'artist-live-stream-edit', params: {id: live.id}}" v-if="live.id">Edit Live Stream</b-nav-item>
        <b-nav-item :to="{name: 'artist-live-stream-manage-comments', params: {id: live.id}}" v-if="live.id">Manage Comments</b-nav-item>
        <b-nav-item :to="{name: 'artist-live-stream-create'}" v-if="!live.id">Create Live Stream</b-nav-item>
      </template>
      <template slot="cmd" slot-scope="{}">
        <router-link class="cancel-link" :to="cancelLink">cancel</router-link>
      </template>
      <template slot="mobileCmd" slot-scope="{}">
        <b-nav-item :to="cancelLink">cancel</b-nav-item>
      </template>
    </ObjectListTabs>

    <b-row class="command-row" align-v="center">
      <b-col>
        <h1 v-if="live.id">
          {{ live.title }}
          <span class="cancelled" v-if="live.is_cancelled">cancelled</span>
        </h1>
        <h1 v-else>
          Create New Live Stream
          <small>Video encoder is required (<router-link :to="{ name: 'site-streaming-guide' }" target="_blank">detailed guide</router-link>)</small>
        </h1>
      </b-col>
      <b-col cols="*" v-if="!live.has_ended || isRecent">
        <LinkButton v-b-modal.confirmDelete :u="true" v-if="live.id && live.visibility === 'draft'">Delete live stream</LinkButton>
        <LinkButton v-b-modal.confirmCancel :u="true" v-if="live.id && live.visibility !== 'draft' && !live.has_ended">Cancel live stream</LinkButton>

        <b-button class="btn-rainbow" @click="saveLiveEvent" v-if="live.id">Update event</b-button>
        <b-button class="btn-rainbow" @click="saveLiveEvent" v-else>Create event</b-button>
      </b-col>
    </b-row>

    <b-row class="live-details first">
      <b-col class="dropzone" v-if="!hasPromo">
        <div class="big-info">
          Select promotional image
        </div>
        <b-button class="btn-rainbow" @click="selectPromoFile">click here to browse</b-button>
        <input type="file" id="promofile" ref="fileInput" @change="onPromoFileSelected">
        <div class="info">
          Supported formats: .png, .jpg <br>
          1920 x 1080 px recommended
        </div>
      </b-col>

      <b-col v-if="hasPromo" class="promoimage">
        <img :src="promoFileUrl">
        <b-button variant="danger" size="xs" class="remove" @click="removePromo">
          <font-awesome-icon icon="times" />
        </b-button>
      </b-col>
      <b-col>
        <b-form-group id="titleGroup"
                      label="Stream Title"
                      :invalidFeedback="errorTitle"
                      :state="stateTitle"
                      label-for="title">
          <b-form-input type="text" placeholder="Live stream title" v-model="live.title" :state="stateTitle" />
        </b-form-group>

        <b-form-group id="visibilityGroup"
                      label="Visibility"
                      :invalidFeedback="errorVisibility"
                      :state="stateVisibility"
                      label-for="visibility">
          <b-form-select v-model="live.visibility" id="visibility" :options="liveEventVisibilities" :state="stateVisibility" />
        </b-form-group>

        <b-form-group id="priceGroup"
                      label="Event Price (USD)"
                      description="Free, or minimum $2.00"
                      :invalidFeedback="errorPrice"
                      :state="statePrice"
                      label-for="price" class="short">
          <b-form-input type="text" required placeholder="Example: 5.00" v-model="live.price" :state="statePrice" />
        </b-form-group>
        <b-form-checkbox v-model="live.can_pay_more" size="sm">
            Let fans back you more, and they might pay a little extra
        </b-form-checkbox>
      </b-col>
    </b-row>

    <b-row class="live-details when">
      <b-col cols="*" class="mr-3">
        <b-form-group id="startGroup"
                      label="Date"
                      label-for="startDate"
                      :invalidFeedback="errorStart"
                      :state="stateStart"
                      description="Date of the event">
          <datepicker id="startDate"
                      calendar-class="start"
                      format="MM/dd/yyyy"
                      :disabledDates="datepickerDisabledDates"
                      v-model="startDate"></datepicker>
        </b-form-group>
      </b-col>
      <b-col cols="*" class="mx-3">
        <b-form-group id="startGroup"
                      label="Starts at"
                      label-for="startTime"
                      :invalidFeedback="errorStart"
                      :state="stateStart"
                      description="Start time">
          <vue-timepicker v-model="startTime" format="hh:mm a"></vue-timepicker>
        </b-form-group>
      </b-col>
      <b-col cols="*" class="mx-3">
        <b-form-group id="durationGroup"
                      label="Duration"
                      label-for="duration" class="short"
                      :invalidFeedback="errorDuration"
                      :state="stateDuration"
                      description="in minutes">
          <b-form-input id="duration" type="text" required placeholder="minutes" v-model="duration" :state="stateDuration" />
        </b-form-group>
      </b-col>
      <b-col class="timezone">
        Time zone: {{ timeZone }}
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group label="How much you want your fans to interact during live stream?"
                      :invalidFeedback="errorChatType"
                      :state="stateChatType"
                      description="This can't be changed after the live stream has started">
          <b-form-select v-model="live.chat_type" id="chat_type" :options="liveEventChatTypes" :state="stateChatType" />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group id="limitGroup"
                      label="Attendee limit"
                      description="Limit number of attendees (optional)"
                      :invalidFeedback="errorLimit"
                      :state="stateLimit"
                      label-for="limit" class="short">
          <b-form-input type="text" required v-model="live.limit" :state="stateLimit" />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group id="locationGroup"
                      label="Live streaming from"
                      label-for="location"
                      description="City or place you're streaming from">
        <vue-google-autocomplete id="location"
                                 classname="form-control"
                                 placeholder="Pick a location"
                                 types="(cities)"
                                 :value="live.location"
                                 v-on:placechanged="onPlaceChanged" />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group id="descGroup"
                      label="Live stream description"
                      label-for="decription">
          <b-form-textarea id="description" :rows="5" :max-rows="10" required placeholder="Description of this live stream" v-model="live.description"></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group label="Instruments (up to 5)"
                      label-for="username">
          <multiselect v-model="live.tags"
                       :searchable="false"
                       :multiple="true"
                       :max="5"
                       :showNoResults="false"
                       :options="instruments">
            <template slot="maxElements">
              Maximum of 5 options
            </template>
          </multiselect>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        Invite participants (use for private events)
        <UserList v-model="invitees"
                  :withRoles="false"
                  :canAdd="true"
                  :canRemove="true"
                  :requireUser="true"
                  addLabel="Invite fan"
                  handleLabel="User handle">
        </UserList>
      </b-col>
    </b-row>

    <b-row class="command-row bottom" align-v="center" v-if="!live.has_ended">
      <b-col>
        <LinkButton v-b-modal.confirmDelete :u="true" v-if="live.id && live.visibility === 'draft'">Delete live stream</LinkButton>
        <LinkButton v-b-modal.confirmCancel :u="true" v-if="live.id && live.visibility !== 'draft'">Cancel live stream</LinkButton>

        <b-button class="btn-rainbow" @click="saveLiveEvent" v-if="live.id">Update event</b-button>
        <b-button class="btn-rainbow" @click="saveLiveEvent" v-else>Create event</b-button>
      </b-col>
    </b-row>

    <b-modal id="confirmDelete"
             ref="confirmDelete"
             title="Delete live stream"
             @ok="deleteLiveStream"
             centered>
      <div class="content">
        <p>
          Are you sure you want to delete this live stream?
        </p>
      </div>
    </b-modal>

    <b-modal id="confirmCancel"
             ref="confirmCancel"
             title="Cancel live stream"
             @ok="cancelLiveStream"
             centered>
      <div class="content">
        <p v-if="startsInTheFuture">
          Are you sure you want to cancel this live streaming event?
          You will not be able to undo this action.
        </p>
        <p v-else>
          Are you sure you want to cancel this live streaming event?
          This will refund any purchases for this live stream automatically.
          You will still be responsible for any applicable processing fees as set forth in Stripe's Service Agreement.
        </p>
      </div>
    </b-modal>

  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';

  .cancel-link {
    color: $white;
  }

  .command-row {
    margin-bottom: 1em;

    a {
      color: $white;
      text-decoration: underline;
    }

    .btn-rainbow {
      margin-left: 2em;
      padding-left: 2em;
      padding-right: 2em;
    }

    h1 {
      font-size: 1.5em;

      span.cancelled {
        font-size: 0.75em;
        color: $tomato;
      }

      small {
        font-size: 0.6em;
        font-weight: normal;
        color: $steel;

        a {
          color: $steel;
        }
      }
    }

    &.bottom {
      margin-top: 1em;
      text-align: right;
    }
  }

  .live-details {
    margin: 0 -15px;
    padding: 1em 0 1em 1em;

    &.first {
      background-image: linear-gradient(to bottom, #1e1f36, rgba(0, 0, 0, 0));
    }

    &.last {
      box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.5);
    }

    .dropzone {
      width: 480px;
      height: 270px;
      display: flex;
      flex-direction: column;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      justify-content: center;
      align-items: center;

      border-image: linear-gradient(107deg, $darkish-pink, $blue-purple) 1;
      border-width: 1px;
      border-style: solid;
      box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.64);

      .big-info {
        margin-bottom: 1em;
      }

      .info {
        text-align: center;
        margin-top: 1em;
        font-size: 0.8em;
        color: $steel;
      }
    }

    .promoimage {
      position: relative;

      img {
        width: 440px;
        height: 248px;
        object-fit: cover;
        object-position: center;
      }

      .remove {
        position: absolute;
        top: 1em;
        right: 2em;
      }
    }
  }

  #promofile {
    display: none;
  }

  .short input.form-control {
    width: 8em;
  }

  .when {
    align-items: center;

    /deep/ div.col-* {
      margin-right: 2em;
    }

    /deep/ .time-picker {
      input {
        border-radius: 4px;
        text-align: center;
      }
    }
  }

  .timezone {
    color: $steel;
  }

</style>

<script>
import moment from '@/utils/moment'
import clone from 'lodash/clone'
import { mapActions } from 'vuex'

import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker'
import VueTimepicker from 'vue2-timepicker'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

import LinkButton from '@/components/widgets/LinkButton'
import UserList from '@/components/widgets/UserList'
import ObjectListTabs from '@/components/widgets/ObjectListTabs'

import { instruments } from '@/store/modules/tag'
import { liveEventVisibilities, liveEventChatTypes } from '@/store/modules/live'
import { parseErrors, mapErrorStates } from '@/store/helpers'

export default {
  name: 'EditLiveStream',
  components: {
    FontAwesomeIcon,
    Multiselect,
    LinkButton,
    Datepicker,
    VueTimepicker,
    VueGoogleAutocomplete,
    UserList,
    ObjectListTabs
  },
  data () {
    const soon = moment().add(1, 'hours')
    const today = moment().startOf('day')

    return {
      errors: {},
      wasPublished: false,
      promoFile: null,
      removedPublishedPromoFile: false,
      promoImageHeight: null,
      uploadProgress: null,
      liveEventVisibilities,
      liveEventChatTypes,
      live: {},
      startDate: today.toDate(),
      invitees: [],
      startTime: {
        hh: soon.format('hh'),
        mm: soon.format('mm'),
        a: soon.format('a')
      },
      datepickerDisabledDates: {
        to: today.toDate()
      },
      duration: '60',
      instruments
    }
  },
  computed: {
    hasPromo () {
      return this.promoFile || this.live.promo_image
    },
    promoFileUrl () {
      if (this.promoFile) return URL.createObjectURL(this.promoFile)
      if (this.live.promo_image) return this.live.promo_image
      return null
    },
    timeZone () {
      try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone
      } catch (e) {
        return 'local time'
      }
    },
    inviteIds () {
      let ids = []
      for (let invitee of this.invitees) {
        if (invitee.user && invitee.user.id) ids.push(invitee.user.id)
      }
      return ids
    },
    cancelLink () {
      if (this.live && this.live.id) {
        if (this.live.has_ended) {
          return {name: 'artist-my-live-stream-list', params: {visibility: 'past'}}
        } else {
          return {name: 'artist-live-stream', params: {id: this.live.id}}
        }
      } else {
        return {name: 'artist-my-live-stream-list', params: {visibility: 'draft'}}
      }
    },
    startsInTheFuture () {
      if (!this.live) return false
      return !this.live.is_live && moment().isBefore(this.live.start)
    },
    isRecent () {
      if (!this.live) return false
      if (this.live.is_live) return true
      return moment().subtract(2, 'hours').isBefore(this.live.start)
    },
    ...mapErrorStates(['title', 'start', 'duration', 'price', 'limit', 'visibility', 'chat_type'])
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    async fetchData () {
      if (!this.$route.params.id) {
        this.live = {}
        return
      }

      let artist = this.$store.getters['artist/artist']
      let live = await this.$store.dispatch('live/getOwnLiveEvent', {id: this.$route.params.id})
      if (live.artist.id !== artist.id) {
        this.$router.push({name: 'artist-dashboard'})
        return
      }

      this.parseLive(live)
    },
    parseLive (live) {
      const startDate = moment(live.start)

      this.startDate = startDate.toDate()
      this.startTime = {
        hh: startDate.format('hh'),
        mm: startDate.format('mm'),
        a: startDate.format('a')
      }
      this.duration = Math.floor((live.duration || 0) / 60)
      this.wasPublished = live.visibility !== 'draft'
      this.live = live

      let invitees = []
      for (let user of live.invited_users) {
        invitees.push({
          user: user,
          handle: '@' + user.username,
          name: user.name || ('@' + user.username)
        })
      }
      this.invitees = invitees
    },
    selectPromoFile () {
      this.$refs.fileInput.click()
    },
    onPromoFileSelected () {
      if (this.$refs.fileInput.files.length !== 1) return
      this.promoFile = this.$refs.fileInput.files[0]
      this.$refs.fileInput.value = ''
    },
    removePromo () {
      this.promoFile = null

      if (this.live.promo_image) {
        this.live.promo_image = null
        this.removedPublishedPromoFile = true
      }
    },
    onPlaceChanged (addr, place, id) {
      this.live.location_lat = addr.latitude
      this.live.location_lng = addr.longitude
      this.live.location = place.formatted_address
    },
    saveDraft () {
      if (!this.live.id) {
        // only set as "draft" if it's a new live stream, otherwise leave the state as-is
        this.live.visibility = 'draft'
      }
      this.saveLiveEvent()
    },
    async saveLiveEvent () {
      // Serialize date/time and duration
      const startDateTime = moment(this.startDate)
      startDateTime.hours((parseInt(this.startTime.hh) || 0) % 12 + ((this.startTime.a === 'pm') ? 12 : 0))
      startDateTime.minutes(this.startTime.mm)
      startDateTime.seconds(0)
      this.live.start = startDateTime.toISOString()

      if (isNaN(parseInt(this.duration))) this.duration = 0

      if (this.duration <= 0) {
        // if no duration is specified, assume 1hr (for start/stop/ended calculations)
        this.duration = 60
        this.live.duration = 3600
      } else if (this.duration < 5) {
        // assume user inputted hours and gracefully handle them
        this.duration = Math.floor(this.duration * 60)
        this.live.duration = this.duration * 60
      } else {
        this.live.duration = Math.round(this.duration * 60)
      }

      this.live.invited_user_ids = this.inviteIds

      // If Google Maps API failed let's just copy the location manually entered, work around the limitations
      // of vue-google-autocomplete
      if (!this.live.location) {
        let raw = document.querySelector('input#location').value
        if (raw) this.live.location = raw.trim()
      }

      let isCreate = !this.live.id
      let resp

      // If this is a new stream, first create it as draft so that image upload can go through
      if (isCreate) {
        this.showModal('Creating new live stream ...')

        let data = clone(this.live)
        let requestedVisibility = this.live.visibility
        data.visibility = 'draft'

        try {
          resp = await this.$store.dispatch('live/createLiveEvent', data)
        } catch (e) {
          this.$store.dispatch('flash/showMessage', {message: 'Error while creating live stream', type: 'error'})
          this.hideModal()
          if (e.response && e.response.data) {
            this.errors = parseErrors(e.response.data)
          }
          return
        }

        // this will reset visibility so we need to change it back to what the user wanted
        this.parseLive(resp)
        this.live.visibility = requestedVisibility
      }

      if (this.removedPublishedPromoFile) {
        this.showModal('Removing old live stream promo ...')
        await this.$store.dispatch('live/deleteLiveEventPromo', { id: this.live.id })
        this.removedPublishedPromoFile = false
      }

      if (this.promoFile) {
        this.showModal('Uploading live stream promo image ...')
        await this.$store.dispatch('live/setLiveEventPromo', { id: this.live.id, file: this.promoFile })
      }

      this.showModal('Saving live stream ...')

      try {
        resp = await this.$store.dispatch('live/updateLiveEvent', this.live)
      } catch (e) {
        this.$store.dispatch('flash/showMessage', {message: 'Error while saving live stream', type: 'error'})
        this.hideModal()
        if (e.response && e.response.data) {
          this.errors = parseErrors(e.response.data)
        }
        return
      }

      this.parseLive(resp)
      this.hideModal()

      if (isCreate) {
        this.$store.dispatch('flash/showMessage', {message: 'Live stream created'})
      } else {
        this.$store.dispatch('flash/showMessage', {message: 'Live stream updated'})
      }

      this.$router.push({name: 'artist-live-stream', params: {id: this.live.id}})
    },
    async deleteLiveStream () {
      if (!this.live.id) return

      if (this.live.visibility !== 'draft') {
        this.$store.dispatch('flash/showMessage', {
          message: 'Published live streams can\'t be deleted, only cancelled',
          type: 'error'
        })
        return
      }

      try {
        await this.$store.dispatch('live/deleteLiveEvent', { id: this.live.id })
      } catch (e) {
        let msg = 'Can\'t delete live stream'
        if (e.response && e.response.data && e.response.data.detail) {
          msg = 'Can\'t delete live stream: ' + e.response.data.detail
        }
        this.$store.dispatch('flash/showMessage', {message: msg, type: 'error'})
        return
      }

      this.$store.dispatch('flash/showMessage', {message: 'Live stream deleted'})
      this.$router.push({name: 'artist-my-live-stream-list', params: {visibility: 'draft'}})
    },
    async cancelLiveStream () {
      if (!this.live.id) return

      if (this.live.visibility === 'draft') {
        this.$store.dispatch('flash/showMessage', {
          message: 'Draft live streams should be deleted instead of cancelled',
          type: 'error'
        })
        return
      }

      try {
        await this.$store.dispatch('live/cancelLiveEvent', { id: this.live.id })
      } catch (e) {
        let msg = 'Can\'t cancel live stream'
        if (e.response && e.response.data && e.response.data.detail) {
          msg = 'Can\'t cancel live stream: ' + e.response.data.detail
        }
        this.$store.dispatch('flash/showMessage', {message: msg, type: 'error'})
        return
      }

      this.$store.dispatch('flash/showMessage', {message: 'Live stream cancelled'})
      this.$router.push({name: 'artist-my-live-stream-list', params: {visibility: this.live.visibility}})
    },

    ...mapActions('flash', ['showModal', 'hideModal'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/artist/EditLiveStream.vue